export default __webpack_public_path__ + "37decb8.png";